export { default as abstract } from '@/assets/icons/abstract.svg';
export { default as activeChecked } from '@/assets/icons/activeChecked.svg';
export { default as adjustments } from '@/assets/icons/adjustments.svg';
export { default as alertTick } from '@/assets/icons/alertTick.svg';
export { default as arrow } from '@/assets/icons/arrow.svg';
export { default as arrowBack } from '@/assets/icons/arrowBack.svg';
export { default as arrowForward } from '@/assets/icons/arrowForward.svg';
export { default as arrowIconCircle } from '@/assets/icons/arrowIconCircle.svg';
export { default as arrowIconCircle1 } from '@/assets/icons/arrowIconCircle1.svg';
export { default as arrowIconWhite } from '@/assets/icons/arrowIconWhite.svg';
export { default as arrowLeft } from '@/assets/icons/arrowLeft.svg';
export { default as arrowLink } from '@/assets/icons/arrowLink.svg';
export { default as arrowNext } from '@/assets/icons/arrowNext.svg';
export { default as arrowPrev } from '@/assets/icons/arrowPrev.svg';
export { default as arrowRight } from '@/assets/icons/arrowRight.svg';
export { default as arrows } from '@/assets/icons/arrows.svg';
export { default as arrowTop } from '@/assets/icons/arrowTop.svg';
export { default as backARIcon } from '@/assets/icons/backARIcon.svg';
export { default as bathroom } from '@/assets/icons/bathroom.svg';
export { default as bedroom } from '@/assets/icons/bedroom.svg';
export { default as bellIcon } from '@/assets/icons/bellIcon.svg';
export { default as BigFilledStar } from '@/assets/icons/BigFilledStar.svg';
export { default as BigNormalStar } from '@/assets/icons/BigNormalStar.svg';
export { default as blackArrowDown } from '@/assets/icons/blackArrowDown.svg';
export { default as boldSearch } from '@/assets/icons/boldSearch.svg';
export { default as briefcase } from '@/assets/icons/briefcase.svg';
export { default as buildHome } from '@/assets/icons/buildHome.svg';
export { default as bulb } from '@/assets/icons/bulb.svg';
export { default as calendar } from '@/assets/icons/calendar.svg';
export { default as calendarTick } from '@/assets/icons/calendarTick.svg';
export { default as calenderIcon } from '@/assets/icons/calenderIcon.svg';
export { default as calenderLeftArrow } from '@/assets/icons/calenderLeftArrow.svg';
export { default as calenderRightArrow } from '@/assets/icons/calenderRightArrow.svg';
export { default as car } from '@/assets/icons/car.svg';
export { default as check } from '@/assets/icons/check.svg';
export { default as checkCircle } from '@/assets/icons/checkCircle.svg';
export { default as checked } from '@/assets/icons/checked.svg';
export { default as checkedDelisting } from '@/assets/icons/checkedDelisting.svg';
export { default as chevronDown } from '@/assets/icons/chevronDown.svg';
export { default as chevronDownWhite } from '@/assets/icons/chevronDownWhite.svg';
export { default as chevronUpWhite } from '@/assets/icons/chevronUpWhite.svg';
export { default as cinema } from '@/assets/icons/cinema.svg';
export { default as circleLoading } from '@/assets/icons/circleLoading.svg';
export { default as circularArrow } from '@/assets/icons/circularArrow.svg';
export { default as clock } from '@/assets/icons/clock.svg';
export { default as clockTicked } from '@/assets/icons/clockTicked.svg';
export { default as close } from '@/assets/icons/close.svg';
export { default as closeButton } from '@/assets/icons/closeButton.svg';
export { default as closeCircle } from '@/assets/icons/closeCircle.svg';
export { default as coffee } from '@/assets/icons/coffee.svg';
export { default as colorSwatch } from '@/assets/icons/colorSwatch.svg';
export { default as comingSoonBanner } from '@/assets/icons/comingSoonBanner.svg';
export { default as compass } from '@/assets/icons/compass.svg';
export { default as completedIcon } from '@/assets/icons/completedIcon.svg';
export { default as completedProjectBorder } from '@/assets/icons/completedProjectBorder.svg';
export { default as confirmTicked } from '@/assets/icons/confirmTicked.svg';
export { default as confirmTickStep } from '@/assets/icons/confirmTickStep.svg';
export { default as confirmVilla } from '@/assets/icons/confirmVilla.svg';
export { default as confirmVillaArabic } from '@/assets/icons/confirmVillaArabic.svg';
export { default as copySuccess } from '@/assets/icons/copySuccess.svg';
export { default as crown } from '@/assets/icons/crown.svg';
export { default as cube } from '@/assets/icons/cube.svg';
export { default as darkStar } from '@/assets/icons/darkStar.svg';
export { default as data } from '@/assets/icons/data.svg';
export { default as defaultStepIcon } from '@/assets/icons/defaultStepIcon.svg';
export { default as deListingContainer } from '@/assets/icons/deListingContainer.svg';
export { default as devices } from '@/assets/icons/devices.svg';
export { default as diningArea } from '@/assets/icons/diningArea.svg';
export { default as dlpBigHighlight } from '@/assets/icons/dlpBigHighlight.svg';
export { default as dlpHighlight } from '@/assets/icons/dlpHighlight.svg';
export { default as dlpIcon } from '@/assets/icons/dlpIcon.svg';
export { default as dlp_smallIcon } from '@/assets/icons/dlp_smallIcon.svg';
export { default as DMTFifthStage } from '@/assets/icons/DMTFifthStage.svg';
export { default as DMTFirstStage } from '@/assets/icons/DMTFirstStage.svg';
export { default as DMTFourthStage } from '@/assets/icons/DMTFourthStage.svg';
export { default as DMTLastStage } from '@/assets/icons/DMTLastStage.svg';
export { default as dmtLeftArrowIcon } from '@/assets/icons/dmtLeftArrowIcon.svg';
export { default as dmtLogo } from '@/assets/icons/dmtLogo.svg';
export { default as dmtRightArrowIcon } from '@/assets/icons/dmtRightArrowIcon.svg';
export { default as DMTSecondStage } from '@/assets/icons/DMTSecondStage.svg';
export { default as DMTSeventhStage } from '@/assets/icons/DMTSeventhStage.svg';
export { default as DMTSixthStage } from '@/assets/icons/DMTSixthStage.svg';
export { default as DMTThirdStage } from '@/assets/icons/DMTThirdStage.svg';
export { default as document } from '@/assets/icons/document.svg';
export { default as documentCad } from '@/assets/icons/documentCad.svg';
export { default as documentDefault } from '@/assets/icons/documentDefault.svg';
export { default as documentExcel } from '@/assets/icons/documentExcel.svg';
export { default as documentPdf } from '@/assets/icons/documentPdf.svg';
export { default as documents } from '@/assets/icons/documents.svg';
export { default as documentUploader } from '@/assets/icons/documentUploader.svg';
export { default as documentWord } from '@/assets/icons/documentWord.svg';
export { default as documentZip } from '@/assets/icons/documentZip.svg';
export { default as dollar } from '@/assets/icons/dollar.svg';
export { default as download } from '@/assets/icons/download.svg';
export { default as downloadBlack } from '@/assets/icons/downloadBlack.svg';
export { default as driver } from '@/assets/icons/driver.svg';
export { default as editBlack } from '@/assets/icons/editBlack.svg';
export { default as elementPlus } from '@/assets/icons/elementPlus.svg';
export { default as elevator } from '@/assets/icons/elevator.svg';
export { default as email } from '@/assets/icons/email.svg';
export { default as email_new } from '@/assets/icons/email_new.svg';
export { default as emptyRadioIcon } from '@/assets/icons/emptyRadioIcon.svg';
export { default as envelop } from '@/assets/icons/envelop.svg';
export { default as errorIcon } from '@/assets/icons/errorIcon.svg';
export { default as example } from '@/assets/icons/example.svg';
export { default as exclamationMark } from '@/assets/icons/exclamationMark.svg';
export { default as expandable } from '@/assets/icons/expandable.svg';
export { default as extentBullet } from '@/assets/icons/extentBullet.svg';
export { default as eye } from '@/assets/icons/eye.svg';
export { default as facebook } from '@/assets/icons/facebook.svg';
export { default as fifthStage } from '@/assets/icons/fifthStage.svg';
export { default as fifthStepJourney } from '@/assets/icons/fifthStepJourney.svg';
export { default as fifthStepJourney_old } from '@/assets/icons/fifthStepJourney_old.svg';
export { default as files } from '@/assets/icons/files.svg';
export { default as filledArrowIconCircle } from '@/assets/icons/filledArrowIconCircle.svg';
export { default as filledStar } from '@/assets/icons/filledStar.svg';
export { default as filledStar_Backup } from '@/assets/icons/filledStar_Backup.svg';
export { default as filterTick } from '@/assets/icons/filterTick.svg';
export { default as finance } from '@/assets/icons/finance.svg';
export { default as fingerPrint } from '@/assets/icons/fingerPrint.svg';
export { default as fingerPrintWhite } from '@/assets/icons/fingerPrintWhite.svg';
export { default as firstStage } from '@/assets/icons/firstStage.svg';
export { default as firstStepJourney } from '@/assets/icons/firstStepJourney.svg';
export { default as firstStepJourney_old } from '@/assets/icons/firstStepJourney_old.svg';
export { default as fourthStage } from '@/assets/icons/fourthStage.svg';
export { default as fourthStepJourney } from '@/assets/icons/fourthStepJourney.svg';
export { default as fourthStepJourney_old } from '@/assets/icons/fourthStepJourney_old.svg';
export { default as gear } from '@/assets/icons/gear.svg';
export { default as general } from '@/assets/icons/general.svg';
export { default as generalHouse } from '@/assets/icons/generalHouse.svg';
export { default as generalNew } from '@/assets/icons/generalNew.svg';
export { default as geoLocation } from '@/assets/icons/geoLocation.svg';
export { default as gpsPosition } from '@/assets/icons/gpsPosition.svg';
export { default as greenTick } from '@/assets/icons/greenTick.svg';
export { default as greyDots } from '@/assets/icons/greyDots.svg';
export { default as grid } from '@/assets/icons/grid.svg';
export { default as gridNew } from '@/assets/icons/gridNew.svg';
export { default as guestRoom } from '@/assets/icons/guestRoom.svg';
export { default as gym } from '@/assets/icons/gym.svg';
export { default as halfCircleArrow } from '@/assets/icons/halfCircleArrow.svg';
export { default as heart } from '@/assets/icons/heart.svg';
export { default as helmetSafety } from '@/assets/icons/helmetSafety.svg';
export { default as home } from '@/assets/icons/home.svg';
export { default as homeGray } from '@/assets/icons/homeGray.svg';
export { default as homeMove } from '@/assets/icons/homeMove.svg';
export { default as hourGlass } from '@/assets/icons/hourGlass.svg';
export { default as humburger } from '@/assets/icons/humburger.svg';
export { default as humburgerDots } from '@/assets/icons/humburgerDots.svg';
export { default as info } from '@/assets/icons/info.svg';
export { default as infoCalculator } from '@/assets/icons/infoCalculator.svg';
export { default as infoNew } from '@/assets/icons/infoNew.svg';
export { default as instagram } from '@/assets/icons/instagram.svg';
export { default as instagramInline } from '@/assets/icons/instagramInline.svg';
export { default as jaggedCheck } from '@/assets/icons/jaggedCheck.svg';
export { default as key } from '@/assets/icons/key.svg';
export { default as kitchen } from '@/assets/icons/kitchen.svg';
export { default as lastStage } from '@/assets/icons/lastStage.svg';
export { default as lastStepJourney } from '@/assets/icons/lastStepJourney.svg';
export { default as lastStepJourney_old } from '@/assets/icons/lastStepJourney_old.svg';
export { default as laundry } from '@/assets/icons/laundry.svg';
export { default as layout } from '@/assets/icons/layout.svg';
export { default as leftArrow } from '@/assets/icons/leftArrow.svg';
export { default as like } from '@/assets/icons/like.svg';
export { default as livingRom } from '@/assets/icons/livingRom.svg';
export { default as locationPin } from '@/assets/icons/locationPin.svg';
export { default as maid } from '@/assets/icons/maid.svg';
export { default as maidRoom } from '@/assets/icons/maidRoom.svg';
export { default as mail } from '@/assets/icons/mail.svg';
export { default as mailNew } from '@/assets/icons/mailNew.svg';
export { default as majlis } from '@/assets/icons/majlis.svg';
export { default as map } from '@/assets/icons/map.svg';
export { default as mapPlaceholder } from '@/assets/icons/mapPlaceholder.svg';
export { default as marker } from '@/assets/icons/marker.svg';
export { default as markerPen } from '@/assets/icons/markerPen.svg';
export { default as markerRed } from '@/assets/icons/markerRed.svg';
export { default as markerSecondary } from '@/assets/icons/markerSecondary.svg';
export { default as markerSelected } from '@/assets/icons/markerSelected.svg';
export { default as markerSelectedSecondary } from '@/assets/icons/markerSelectedSecondary.svg';
export { default as MarketPlaceCloseIcon } from '@/assets/icons/MarketPlaceCloseIcon.svg';
export { default as meetingCalendar } from '@/assets/icons/meetingCalendar.svg';
export { default as menu } from '@/assets/icons/menu.svg';
export { default as minus } from '@/assets/icons/minus.svg';
export { default as mobile } from '@/assets/icons/mobile.svg';
export { default as mobile_call } from '@/assets/icons/mobile_call.svg';
export { default as money } from '@/assets/icons/money.svg';
export { default as mouse } from '@/assets/icons/mouse.svg';
export { default as mouseBlack } from '@/assets/icons/mouseBlack.svg';
export { default as multipleUsers } from '@/assets/icons/multipleUsers.svg';
export { default as new_star_Icon } from '@/assets/icons/new_star_Icon.svg';
export { default as nonExpandable } from '@/assets/icons/nonExpandable.svg';
export { default as normalStar } from '@/assets/icons/normalStar.svg';
export { default as office } from '@/assets/icons/office.svg';
export { default as officeBag } from '@/assets/icons/officeBag.svg';
export { default as openBox } from '@/assets/icons/openBox.svg';
export { default as pantry } from '@/assets/icons/pantry.svg';
export { default as parking } from '@/assets/icons/parking.svg';
export { default as parkingSign } from '@/assets/icons/parkingSign.svg';
export { default as pendingBullet } from '@/assets/icons/pendingBullet.svg';
export { default as pendingBullet_1 } from '@/assets/icons/pendingBullet_1.svg';
export { default as penRuler } from '@/assets/icons/penRuler.svg';
export { default as people } from '@/assets/icons/people.svg';
export { default as peopleWhite } from '@/assets/icons/peopleWhite.svg';
export { default as phone } from '@/assets/icons/phone.svg';
export { default as phoneNew } from '@/assets/icons/phoneNew.svg';
export { default as pin } from '@/assets/icons/pin.svg';
export { default as play } from '@/assets/icons/play.svg';
export { default as plus } from '@/assets/icons/plus.svg';
export { default as plusCircle } from '@/assets/icons/plusCircle.svg';
export { default as poiSelected } from '@/assets/icons/poiSelected.svg';
export { default as profile } from '@/assets/icons/profile.svg';
export { default as profileCircle } from '@/assets/icons/profileCircle.svg';
export { default as profileDeListedIcon } from '@/assets/icons/profileDeListedIcon.svg';
export { default as profileVerifiedIcon } from '@/assets/icons/profileVerifiedIcon.svg';
export { default as progressBullet } from '@/assets/icons/progressBullet.svg';
export { default as question } from '@/assets/icons/question.svg';
export { default as questionGear } from '@/assets/icons/questionGear.svg';
export { default as questionNew } from '@/assets/icons/questionNew.svg';
export { default as questionNewAR } from '@/assets/icons/questionNewAR.svg';
export { default as questionOutlined } from '@/assets/icons/questionOutlined.svg';
export { default as questionOutlinedAR } from '@/assets/icons/questionOutlinedAR.svg';
export { default as radio } from '@/assets/icons/radio.svg';
export { default as rating } from '@/assets/icons/rating.svg';
export { default as redExclamation } from '@/assets/icons/redExclamation.svg';
export { default as refresh } from '@/assets/icons/refresh.svg';
export { default as rejectIcon } from '@/assets/icons/rejectIcon.svg';
export { default as reScheduleIcon } from '@/assets/icons/reScheduleIcon.svg';
export { default as rightArrow } from '@/assets/icons/rightArrow.svg';
export { default as rocket } from '@/assets/icons/rocket.svg';
export { default as roomKey } from '@/assets/icons/roomKey.svg';
export { default as roundedTick } from '@/assets/icons/roundedTick.svg';
export { default as search } from '@/assets/icons/search.svg';
export { default as secondStage } from '@/assets/icons/secondStage.svg';
export { default as secondStepJourney } from '@/assets/icons/secondStepJourney.svg';
export { default as secondStepJourney_old } from '@/assets/icons/secondStepJourney_old.svg';
export { default as serviceTimes } from '@/assets/icons/serviceTimes.svg';
export { default as share } from '@/assets/icons/share.svg';
export { default as signOut } from '@/assets/icons/signOut.svg';
export { default as sofa } from '@/assets/icons/sofa.svg';
export { default as squareCheck } from '@/assets/icons/squareCheck.svg';
export { default as star } from '@/assets/icons/star.svg';
export { default as starEmpty } from '@/assets/icons/starEmpty.svg';
export { default as starFill } from '@/assets/icons/starFill.svg';
export { default as starHalf } from '@/assets/icons/starHalf.svg';
export { default as successTick } from '@/assets/icons/successTick.svg';
export { default as support } from '@/assets/icons/support.svg';
export { default as supportNew } from '@/assets/icons/supportNew.svg';
export { default as swimmingpool } from '@/assets/icons/swimmingpool.svg';
export { default as tableEtiquette } from '@/assets/icons/tableEtiquette.svg';
export { default as teayseer } from '@/assets/icons/teayseer.svg';
export { default as test123 } from '@/assets/icons/test123.svg';
export { default as thirdStage } from '@/assets/icons/thirdStage.svg';
export { default as thirdStageArabic } from '@/assets/icons/thirdStageArabic.svg';
export { default as thirdStepJourney } from '@/assets/icons/thirdStepJourney.svg';
export { default as thirdStepJourneyArabic } from '@/assets/icons/thirdStepJourneyArabic.svg';
export { default as thirdStepJourneyArabic_old } from '@/assets/icons/thirdStepJourneyArabic_old.svg';
export { default as thirdStepJourney_old } from '@/assets/icons/thirdStepJourney_old.svg';
export { default as tickMark } from '@/assets/icons/tickMark.svg';
export { default as timelineKey } from '@/assets/icons/timelineKey.svg';
export { default as trowelBricks } from '@/assets/icons/trowelBricks.svg';
export { default as twitter } from '@/assets/icons/twitter.svg';
export { default as twoChevronDown } from '@/assets/icons/twoChevronDown.svg';
export { default as uaeFlag } from '@/assets/icons/uaeFlag.svg';
export { default as uploadDocuments } from '@/assets/icons/uploadDocuments.svg';
export { default as user } from '@/assets/icons/user.svg';
export { default as userHelmet } from '@/assets/icons/userHelmet.svg';
export { default as userHelmetSafety } from '@/assets/icons/userHelmetSafety.svg';
export { default as users } from '@/assets/icons/users.svg';
export { default as userTick } from '@/assets/icons/userTick.svg';
export { default as utility } from '@/assets/icons/utility.svg';
export { default as vector } from '@/assets/icons/vector.svg';
export { default as vendor } from '@/assets/icons/vendor.svg';
export { default as vendorRating } from '@/assets/icons/vendorRating.svg';
export { default as wave } from '@/assets/icons/wave.svg';
export { default as web } from '@/assets/icons/web.svg';
export { default as website } from '@/assets/icons/website.svg';
export { default as whatsapp } from '@/assets/icons/whatsapp.svg';
export { default as yellowDots } from '@/assets/icons/yellowDots.svg';
export { default as yellowInfo } from '@/assets/icons/yellowInfo.svg';
export { default as youtube } from '@/assets/icons/youtube.svg';
export { default as zoomOutArrow } from '@/assets/icons/zoomOutArrow.svg';
export { default as consultantIcon } from '@/assets/icons/consultantIcon.svg';
export { default as contractorIcon } from '@/assets/icons/contractorIcon.svg';
export { default as moveRight } from '@/assets/icons/moveRight.svg';
export { default as flaguae } from '@/assets/icons/flaguae.svg';
export { default as uploadIcon } from '@/assets/icons/uploadIcon.svg';
export { default as uploadIconSmall } from '@/assets/icons/uploadIconSmall.svg';
export { default as iconpdf } from '@/assets/icons/iconPdf.svg';
export { default as closeIconRound } from '@/assets/icons/closeIconRound.svg';
export { default as alertCircle } from '@/assets/icons/alertCircle.svg';
export { default as searchLong } from '@/assets/icons/searchLong.svg';
export { default as stopIcon } from '@/assets/icons/stopIcon.svg';